<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->

		<Form ref="SystemForm" style="margin-top: 2%;margin-left: 20%;" :model="SystemForm" :rules="SystemFormRuler" :label-width="70">
			<Row>
				<Col span="10">
					<div>{{$tt('设备参数')}}</div>
				<FormItem :label="$tt('数据上报间隔(分钟)')" prop="interval">
					<Input  v-model="SystemForm.interval" :placeholder="$tt('输入设备id')"></Input>
				</FormItem>
				<FormItem :label="$tt('离线时长(分钟)')" prop="offLine">
					<Input  v-model="SystemForm.offLine" :placeholder="$tt('输入设备编号')"></Input>
				</FormItem>

				</Col>


				<Col span="10">
					<div>{{$tt('设备参数')}}</div>
				<FormItem :label="$tt('路过时长（秒）')" prop="passby">
					<Input v-model="SystemForm.passby" :placeholder="$tt('输入设备sim卡号')"></Input>
				</FormItem>	
				<FormItem :label="$tt('逗留时长（秒）')" prop="stay">
					<Input v-model="SystemForm.stay" :placeholder="$tt('输入设备安装地址')"></Input>
				</FormItem>

				<FormItem :label="$tt('常驻时长（秒）')" prop="resident">
					<Input v-model="SystemForm.resident" :placeholder="$tt('输入设备维度')"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row>
				<Col span="15">
					  <FormItem>
					            <Button type="primary" @click="handleSubmit()">{{$tt('修改参数')}}</Button>
					            <Button @click="handleReset()" style="margin-left: 8px">{{$tt('重置默认')}}</Button>
					    </FormItem>
				</Col>
			</Row>
		</Form>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				BreadcrumbList: [this.$tt('追踪管理'), this.$tt('系统功能'), this.$tt('系统参数设置')],
				name: 1,

				SystemForm: {
					interval: '',
					offLine: '',
					passby: '',
					stay: '',
					resident: ''
				},
				SystemFormRuler:{
					interval: [{
						required: true,
						message: this.$tt('此项不为空,且值为数字'),
						type:"number",
						trigger: 'blur'
					}],
					offLine: [{
						required: true,
						message: this.$tt('此项不为空,且值为数字'),
						type:"number",
						trigger: 'blur'
					}],
					passby: [{
						required: true,
						message: this.$tt('此项不为空,且值为数字'),
						type:"number",
						trigger: 'blur'
					}],
					stay: [{
						required: true,
						message: this.$tt('此项不为空,且值为数字'),
						type:"number",
						trigger: 'blur'
					}],
					resident: [{
						required: true,
						message: this.$tt('此项不为空,且值为数字'),
						type:"number",
						trigger: 'blur'
					}],
				}
			};
		},
		mounted() {},
		created() {
			this.getSystemInfo()
		},

		methods: {
			getSystemInfo: function() {
				const _this = this;
				let parms = _this.DeviceForm;
				_this.$axios.post("/gateway/config/query", parms, {

				}).then(res => {
					
					if (res.data.status == 1) {
						

						_this.SystemForm = res.data.data;



					} else {
						_this.$Message.error(this.$tt('系统参数查询失败'));
					}
				})
			},
			
			handleSubmit:function(){
				const _this = this;
				let parms = _this.SystemForm;
				_this.$axios.post("/gateway/config/updateValues", parms, {
				
				}).then(res => {
					
					if (res.data.status == 1) {
						_this.$Message.success(this.$tt('添加成功'));
						_this.getSystemInfo();
				
				
					} else {
						_this.$Message.error(this.$tt('添加失败'));
					}
				})
				
				
			},
			handleReset:function(){
				
				const _this = this;
				let parms={
					interval: 1,
					offLine: 1,
					passby: 1,
					stay: 1,
					resident: 1
				};
				_this.$axios.post("/gateway/config/updateValues", parms, {
				
				}).then(res => {
					
					if (res.data.status == 1) {
						_this.$Message.success(this.$tt('重置成功'));
						_this.getSystemInfo();
				
				
					} else {
						_this.$Message.error(this.$tt('重置失败'));
					}
				})
			}
		},

	}
</script>

<style>
</style>
